export default __webpack_public_path__ + "static/media/carnegie_mellon.1d39b687.png";